import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import ReportModelBase from '../ReportModelBase';
import { Table } from 'semantic-ui-react';

class EmployeeReportModelGroupByBirthMonth extends ReportModelBase {

    constructor(props){
        super(props);
        this.searchUrl = "api/Reports/employeeReportGroupByBirthMonth";
        this.title = "Employee Report Group by BirthMonth";
        this.exportToExcelUrl = "api/Reports/ExportEmployeeReportGroupByBirthMonthToExcel";
        this.exportToPdfUrl = "api/Reports/ExportEmployeeReportGroupByBirthMonthToPDF";
    }

    toTableRow = (rowData) => {
        return (
            <Table.Row>
                <Table.Cell>{rowData["Employee No"]}</Table.Cell>
                <Table.Cell>{rowData["Employee"]}</Table.Cell>
                <Table.Cell>{rowData["Age"]}</Table.Cell>
                <Table.Cell>{rowData["Birthdate"]}</Table.Cell>
            </Table.Row>
        );
    }

    createColumnHeaders = () => {
        return (
            <Table.Row>
                <Table.HeaderCell>Employee No</Table.HeaderCell>
                <Table.HeaderCell>Employee</Table.HeaderCell>
                <Table.HeaderCell>Age</Table.HeaderCell>
                <Table.HeaderCell>Birthdate</Table.HeaderCell>
            </Table.Row>
        );
    }

}
export default EmployeeReportModelGroupByBirthMonth;